<template>
  <AppBody title="Configurações" subtitle="Config. de Ambientes">
    <Tabs :tabs="tabs">
      <VTabItem> <General /> </VTabItem>
      <VTabItem> <Store /> </VTabItem>
      <VTabItem> <MarketplaceSettings /> </VTabItem>
    </Tabs>
  </AppBody>
</template>
<script>
import AppBody from "@/layouts/components/AppBody.vue";
import Tabs from "@/components/global/Tabs.vue";
import General from "@/views/configuracoes/General.vue";
import MarketplaceSettings from "@/views/configuracoes/MarketplaceSettings.vue";
import Store from "@/views/configuracoes/Store.vue";
export default {
  name: "GeneralSettings",
  metaInfo: {
    title: "Configurações | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Configurações | ElevenTickets",
      },
    ],
  },
  components: {
    AppBody,
    Tabs,
    General,
    MarketplaceSettings,
    Store,
  },
  computed: {
    tabs() {
      return [{ tab: "Geral" }, { tab: "Loja" }, { tab: "Marketplace" }];
    },
  },
};
</script>
